import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Flag, X } from "lucide-react";

const REASONS = [
  { value: "inapproprie", label: "Contenu inapproprié" },
  { value: "contrefacon", label: "Contrefaçon" },
  { value: "arnaque", label: "Arnaque / fraude" },
  { value: "harcelement", label: "Harcèlement" },
  { value: "spam", label: "Spam" },
  { value: "autre", label: "Autre" },
];

export const ReportDialog = ({ targetType, targetId, targetLabel, onClose }) => {
  const [reason, setReason] = useState("inapproprie");
  const [details, setDetails] = useState("");
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const { data } = await api.post("/reports", { target_type: targetType, target_id: targetId, reason, details: details.trim() || null });
      toast.success(data.already_reported ? "Déjà signalé — notre équipe est prévenue" : "Signalement envoyé. Merci !");
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erreur lors du signalement");
    } finally { setSending(false); }
  };

  return (
    <div className="fixed inset-0 z-[100] bg-black/60 flex items-center justify-center p-4" onClick={onClose} data-testid="report-dialog">
      <form onSubmit={submit} onClick={e=>e.stopPropagation()} className="bg-white border-2 border-black w-full max-w-md p-5 space-y-4 max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between">
          <p className="font-black text-lg tracking-tight inline-flex items-center gap-2"><Flag size={18}/> Signaler</p>
          <button type="button" onClick={onClose} aria-label="Fermer" data-testid="report-close-btn"><X size={20}/></button>
        </div>
        {targetLabel && <p className="text-sm text-[color:var(--color-text-muted)] truncate">Cible : {targetLabel}</p>}
        <div>
          <p className="label font-bold mb-2">Motif</p>
          <div className="space-y-1.5">
            {REASONS.map(r => (
              <label key={r.value} className={`flex items-center gap-2 p-2 border-2 cursor-pointer text-sm ${reason===r.value ? "border-black bg-[color:var(--color-mint)]" : "border-transparent hover:bg-[color:var(--color-surface)]"}`}>
                <input type="radio" name="reason" value={r.value} checked={reason===r.value} onChange={()=>setReason(r.value)} data-testid={`report-reason-${r.value}`}/>
                <span className="font-bold">{r.label}</span>
              </label>
            ))}
          </div>
        </div>
        <textarea rows="3" className="field" placeholder="Détails (optionnel)" value={details} onChange={e=>setDetails(e.target.value)} maxLength={1000} data-testid="report-details-input"/>
        <button type="submit" disabled={sending} className="btn btn-coral w-full" data-testid="report-submit-btn">
          {sending ? "Envoi…" : "Envoyer le signalement"}
        </button>
      </form>
    </div>
  );
};

export default ReportDialog;
